import { gql } from '@apollo/client';

export const GET_AUDIT_SESSIONS = gql`
  query GetAuditSessions($communityId: ID!, $page: Int, $pageSize: Int, $status: String) {
    community(id: $communityId) {
      id
      name
      communityGroupId
      logoUrl
      optionalMetadata {
        description
        pgRating
        contentGenres
        contentStandardsUrl
        bigId
      }
      auditSessions(page: $page, pageSize: $pageSize, status: $status) {
        id
        name
        status
        createdBy
        createdAt
        completedAt
        itemsCount
        completedCount
        skippedCount
        pendingCount
        sampleParameters {
          communityId
          samplingParameters {
            confidenceLevel
            marginOfError
            populationProportion
            timeframe {
              start
              end
            }
          }
          filters {
            languages
            topics
            labels
            labelSeverities
            contentTypes
          }
        }
      }
    }
  }
`;
